import { SectionHandler } from '../entity.handler';
import { AssetUpdateRequest, AssetResponse, AssetLocation } from '@key-telematics/fleet-api-client';
import { AdminEditorService } from '../../admin.service';
import { EntityUtils } from '../utils';
import { FormBuilderField, FormBuilderAction } from 'app/shared/components/form-builder';
import { LocationSelectModalComponent } from 'app/shared/components/modal/location-select-modal/location-select-modal.component';

export interface LocationEntity {
    id: string;
    location?: Location;
}

export class AssetLocationSectionHandler implements SectionHandler<AssetResponse, any> {

    type = 'form';
    icon = 'map-pin';
    bulk = false;

    title = this.translate('TITLE');
    description = this.translate('DESC');

    constructor(
        public admin: AdminEditorService,
        public ownerId: string
    ) {
    }

    translate(key: string, values?: Object): string {
        return this.admin.translate(`EDITORS.ASSET.LOCATION.${key}`, values);
    }

    applyUpdate(entity: AssetResponse, _payload: any): Promise<any> {
        return this.admin.applyUpdate(api => api.entities.updateAsset(entity.id, { location: entity.location }));
    }

    mapEntityToEditor(entity: AssetResponse): Promise<AssetLocation> {
        return Promise.resolve(entity.location || {} as AssetLocation);
    }

    mapEditorToEntity(entity: AssetUpdateRequest, _values: AssetLocation): Promise<AssetUpdateRequest> {
        return Promise.resolve(entity);
    }

    getFields(entity: AssetResponse): Promise<FormBuilderField[]> {
        return Promise.resolve([
            {
                id: 'location',
                title: this.translate('TITLE'),
                type: 'list',
                getValue: (field: FormBuilderField, _values: any) => {
                    field.actions = this.getActions(entity);
                    return entity.location && !!Object.keys(entity.location).length ? [{
                        id: entity.id,
                        name: entity.location.address,
                        icon: 'map-marker-alt',
                    }] : [];
                },
                getText: (_field: FormBuilderField, value: AssetLocation) => value && value.address,
                actions: this.getActions(entity),
            },
        ]).then(fields => EntityUtils.prepareBulk(!entity, ['location'], fields));
    }

    getActions(entity: AssetResponse): FormBuilderAction[] {
        return entity.location
            ? [
                { id: 'edit', name: this.admin.i18n.instant('DIALOG.EDIT'), click: async () => this.showModal(entity) },
                { id: 'delete', click: async () => {
                    entity.location = null;
                    return true;
                } },
            ] : [{ id: 'add', name: this.admin.i18n.instant('DIALOG.ADD'), click: () => this.showModal(entity) }];
    }

    async showModal(entity: AssetResponse): Promise<AssetResponse> {
        entity['location'] = entity.location || {} as AssetLocation;
        const location = await LocationSelectModalComponent.open(this.admin.modal, {
            address: entity.location.address,
            lat: entity.location.lat,
            lon: entity.location.lon,
        });

        if (location) {
            entity.location = {
                address: location.address,
                lat: location.lat,
                lon: location.lon,
            };
            return entity;
        }
    }

}
